export default "__VITE_ASSET__K5At_SsE__"